import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
};

export const LangSlice = createSlice({
  name: 'langslice',
  initialState,
  reducers: {
    setLang: (state, action) => {
      return {
        ...state,
        data: action.payload,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setLang } = LangSlice.actions;

export default LangSlice.reducer;
